import React from 'react';
import * as Sentry from '@sentry/browser/dist/index';
import {FormattedMessage} from 'react-intl';

import Button from '@material-ui/core/Button';

const Error = () => {
    return (
        <div className="error-page">
            <h1><FormattedMessage id="error.report.title"/></h1>
            <p><FormattedMessage id="error.report.message"/></p>
            <Button
                onClick={() => Sentry.showReportDialog()}
                variant="outlined"
            >
                <FormattedMessage id="error.report.button"/>
            </Button>
        </div>
    );
};

export default Error;


// WEBPACK FOOTER //
// ./src/components/common/Error.js